import { render, staticRenderFns } from "./TemplatesManagerModalWrapper.vue?vue&type=template&id=29b2bd60&"
import script from "./TemplatesManagerModalWrapper.vue?vue&type=script&lang=js&"
export * from "./TemplatesManagerModalWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports